import { render, staticRenderFns } from "./text_panelcomponent.vue?vue&type=template&id=8f7da82a&"
import script from "./text_panelcomponent.vue?vue&type=script&lang=ts&"
export * from "./text_panelcomponent.vue?vue&type=script&lang=ts&"
import style0 from "./text_panelcomponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports